import { render, staticRenderFns } from "./TomsEdit.vue?vue&type=template&id=164ca568"
import script from "./TomsEdit.vue?vue&type=script&lang=js"
export * from "./TomsEdit.vue?vue&type=script&lang=js"
import style0 from "./TomsEdit.vue?vue&type=style&index=0&id=164ca568&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports